/* ZenPasta product-finder quiz v2 — vanilla, no deps. Drives sections/quiz-v2.liquid.
   v2.1 (post blue/red-team review): single primary card + dormant bundle slot,
   pick() falls down tiers within the craved format before switching (upsell only
   as last resort), click-time availability re-check with re-pick, fallback-aware
   echo copy, unlock survives restart, discount auto-apply on every product link,
   neutral ref= params (internal UTMs would overwrite acquisition attribution).
   Debug hook unchanged: ?zpq2=dish:short,goal:sugar,...,step:result (+unlock:1). */
(function () {
  'use strict';

  var STEP_ORDER = ['intro', 'dish', 'goal', 'tried', 'freq', 'calc', 'result'];
  var QUESTIONS = ['dish', 'goal', 'tried', 'freq'];
  var REF_BASE = 'ref=zpq';

  /* format = f(dish, goal). Penne excluded for keto + sugar: it contains wheat
     (~17g carbs/100g) — recommending it to those goals is a credibility killer. */
  var FORMAT_CHAINS = {
    spaghetti: ['shirataki', 'risino', 'rigataki'],
    risotto: ['risino', 'shirataki', 'rigataki'],
    short: {
      keto: ['rigataki', 'shirataki', 'risino'],
      sugar: ['rigataki', 'shirataki', 'risino'],
      weight: ['penne', 'rigataki', 'risino'],
      lighter: ['penne', 'rigataki', 'risino'],
      protein: ['penne', 'rigataki', 'shirataki']
    },
    all: {
      keto: ['bundle', 'shirataki', 'rigataki'],
      weight: ['bundle', 'risino', 'shirataki'],
      lighter: ['bundle', 'rigataki', 'risino'],
      sugar: ['bundle', 'rigataki', 'shirataki'],
      protein: ['bundle', 'penne', 'rigataki']
    }
  };

  function formatChain(dish, goal) {
    var c = FORMAT_CHAINS[dish] || FORMAT_CHAINS.spaghetti;
    if (Object.prototype.toString.call(c) === '[object Array]') return c;
    return c[goal] || ['shirataki', 'risino', 'rigataki'];
  }

  /* pack tier = f(freq, tried): commitment scales with stated usage,
     discounted one notch for first-timers (price objection). */
  function targetTier(freq, tried) {
    if (freq === 'rarely') return 0;
    if (freq === 'daily') return tried === 'yes' ? 3 : 2;
    return tried === 'yes' ? 2 : 1; // weekly
  }

  function track(event, data, isDebug) {
    var payload = { event: event };
    if (data) for (var k in data) if (data.hasOwnProperty(k)) payload[k] = data[k];
    if (isDebug) payload.debug = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function euros(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* "Per [profile]" mid-sentence: Italian requires the article lowercased
     ("per il Determinato Keto"), while the <h3> keeps the capital. */
  function lcArticle(name) {
    return name.replace(/^(Il |Lo |La |I |Gli |Le |Un |Una |Uno |L’|L')/, function (m) {
      return m.toLowerCase();
    });
  }

  function parseDebug() {
    var m = location.search.match(/[?&]zpq2=([^&]+)/);
    if (!m) return null;
    var out = {};
    decodeURIComponent(m[1]).split(',').forEach(function (kv) {
      var p = kv.split(':');
      if (p.length === 2) out[p[0]] = p[1];
    });
    return out;
  }

  function initQuiz(root) {
    if (root.__zpq2Init) return;
    root.__zpq2Init = true;

    var sectionEl = root.closest('[data-section-id]');
    var sectionId = sectionEl ? sectionEl.getAttribute('data-section-id') : 'x';
    var cfgEl = root.querySelector('[data-zpq-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var K = {
      state: 'zpq2_state_' + sectionId,
      pending: 'zpq2_pending_' + sectionId,
      unlock: 'zpq2_unlock_' + sectionId,
      unlockTracked: 'zpq2_unlock_tracked_' + sectionId,
      completeTracked: 'zpq2_complete_tracked_' + sectionId
    };
    function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
    function sdel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }

    var state = { dish: null, goal: null, tried: null, freq: null };
    var debugMode = false;
    var rewardUnlockTracked = false;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var steps = {};
    root.querySelectorAll('[data-zpq-step]').forEach(function (el) {
      steps[el.getAttribute('data-zpq-step')] = el;
    });
    var bar = root.querySelector('[data-zpq2-bar]');
    var progressLabel = root.querySelector('[data-zpq2-progress]');

    /* ---- card pool index: {format: {tier: [el, …]}} — available only ---- */
    var pool = {};
    root.querySelectorAll('[data-zpq-card]').forEach(function (c) {
      if (c.getAttribute('data-available') !== 'true') return;
      var f = c.getAttribute('data-format');
      var t = c.getAttribute('data-tier');
      pool[f] = pool[f] || {};
      (pool[f][t] = pool[f][t] || []).push(c);
    });

    /* Craved format wins on the way DOWN (any smaller size of the dish-true
       format beats switching format); an above-target tier is a LAST resort,
       reached only when nothing at-or-below target exists in any chain format
       — and then nearest tier first, so the overshoot is minimal. */
    function pick(formats, target) {
      var f, t, arr, byTier;
      for (f = 0; f < formats.length; f++) {
        byTier = pool[formats[f]];
        if (!byTier) continue;
        for (t = target; t >= 0; t--) {
          arr = byTier[String(t)];
          if (arr && arr.length) return arr[0];
        }
      }
      for (t = target + 1; t <= 3; t++) {
        for (f = 0; f < formats.length; f++) {
          arr = (pool[formats[f]] || {})[String(t)];
          if (arr && arr.length) return arr[0];
        }
      }
      return null;
    }

    /* Discovery slot below the gate: bundles only, lowest commitment first.
       Renders nothing while all curated bundles are OOS. */
    function pickBundle(primary) {
      if (!primary || primary.getAttribute('data-format') === 'bundle') return null;
      var byTier = pool.bundle;
      if (!byTier) return null;
      for (var t = 1; t <= 3; t++) {
        var arr = byTier[String(t)];
        if (arr && arr.length) return arr[0];
      }
      return null;
    }

    function cheapestStarter(primary) {
      // [price] anchor for the first-timer reassurance: cheapest available card,
      // preferring the recommended format's tier 0
      var pf = primary ? primary.getAttribute('data-format') : null;
      var best = null;
      root.querySelectorAll('[data-zpq-card][data-available="true"]').forEach(function (c) {
        if (c.getAttribute('data-tier') !== '0') return;
        if (pf && c.getAttribute('data-format') !== pf) return;
        var cents = parseInt(c.getAttribute('data-price-cents'), 10);
        if (!best || cents < parseInt(best.getAttribute('data-price-cents'), 10)) best = c;
      });
      if (!best && pf) { // recommended format has no starter in stock → any format
        root.querySelectorAll('[data-zpq-card][data-available="true"][data-tier="0"]').forEach(function (c) {
          var cents = parseInt(c.getAttribute('data-price-cents'), 10);
          if (!best || cents < parseInt(best.getAttribute('data-price-cents'), 10)) best = c;
        });
      }
      return best;
    }

    /* ---- click-time availability re-check (data-available is frozen at
       render; a tab left open across a stockout would recommend a dead PDP).
       Optimistic: paint from render-time data, verify in the background,
       re-pick + repaint on discovery. Any fetch problem degrades to the
       render-time answer — never destructive. ---- */
    var availCache = {};
    function checkAvailable(handle) {
      if (!handle) return Promise.resolve(true);
      if (availCache[handle]) return availCache[handle];
      var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      availCache[handle] = new Promise(function (resolve) {
        var ctrl = window.AbortController ? new AbortController() : null;
        var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 2500);
        fetch(rootPath + 'products/' + handle + '.js', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) { clearTimeout(timer); resolve(!data || data.available !== false); })
          .catch(function () { clearTimeout(timer); resolve(true); });
      });
      return availCache[handle];
    }

    function markUnavailable(card) {
      card.setAttribute('data-available', 'false');
      var arr = (pool[card.getAttribute('data-format')] || {})[card.getAttribute('data-tier')];
      if (arr) {
        var i = arr.indexOf(card);
        if (i > -1) arr.splice(i, 1);
      }
    }

    /* ---- step display ---- */
    function show(name) {
      STEP_ORDER.forEach(function (n) {
        if (!steps[n]) return;
        var active = n === name;
        steps[n].classList.toggle('is-active', active);
        steps[n].setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      // endowed progress: start at 15%, finish at 100%
      var idx = STEP_ORDER.indexOf(name);
      if (bar) bar.style.width = (15 + (idx / (STEP_ORDER.length - 1)) * 85) + '%';
      if (progressLabel) {
        var qIdx = QUESTIONS.indexOf(name);
        progressLabel.textContent = qIdx >= 0 ? cfg.progressTemplate.replace('[n]', qIdx + 1) : '';
      }
      if (name !== 'intro') {
        var h = steps[name].querySelector('.zp-quiz2__q, h3');
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
        var top = steps[name].getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.5) {
          steps[name].scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        }
      }
    }

    function save(step) {
      sset(K.state, JSON.stringify({ dish: state.dish, goal: state.goal, tried: state.tried, freq: state.freq, step: step || null }));
    }

    function isUnlocked() {
      return !cfg.gateEnabled || sget(K.unlock) === '1';
    }

    function echoLabel(question, value) {
      var btn = root.querySelector('[data-zpq-answer][data-question="' + question + '"][data-value="' + value + '"]');
      return btn ? (btn.getAttribute('data-echo') || '') : '';
    }

    function fillCard(el, card, params) {
      if (!el) return;
      if (!card) { el.hidden = true; return; }
      el.hidden = false;
      var target = card.getAttribute('data-url') + '?' + params;
      el.setAttribute('data-zpq-target', target);
      el.href = target;
      el.setAttribute('data-handle', card.getAttribute('data-handle'));
      var img = el.querySelector('img');
      var src = card.getAttribute('data-img');
      if (src) { img.src = src; img.alt = card.getAttribute('data-title'); img.hidden = false; }
      else img.hidden = true;
      el.querySelector('.zp-quiz2__card-title').textContent = card.getAttribute('data-title');
      el.querySelector('.zp-quiz2__card-price').textContent = card.getAttribute('data-price');
    }

    /* reassurance copy templates are read once (JS substitutes [price]/[cheap] in place) */
    var reassureStrongEl = root.querySelector('[data-zpq2-reassure="strong"]');
    var reassureLightEl = root.querySelector('[data-zpq2-reassure="light"]');
    var reassureLightTpl = reassureLightEl ? reassureLightEl.textContent : '';

    function applyGateState(primary, params) {
      var unlocked = isUnlocked();
      var lockedEl = root.querySelector('[data-zpq-locked]');
      var unlockedEl = root.querySelector('[data-zpq-unlocked]');
      if (lockedEl) lockedEl.hidden = unlocked || !cfg.gateEnabled;
      if (unlockedEl) unlockedEl.hidden = !unlocked;
      function discountHref(target) {
        return (unlocked && cfg.discount)
          ? '/discount/' + cfg.discount + '?redirect=' + encodeURIComponent(target)
          : target;
      }
      var cta = root.querySelector('[data-zpq-cta]');
      if (cta) {
        var target = primary ? primary.getAttribute('data-url') + '?' + params : '/collections/all?' + params;
        cta.href = discountHref(target);
        cta.setAttribute('data-handle', primary ? primary.getAttribute('data-handle') : '');
      }
      // the product cards are the most-clicked elements — they must carry the
      // unlocked code too, not just the small CTA
      root.querySelectorAll('[data-zpq2-card]').forEach(function (el) {
        var t = el.getAttribute('data-zpq-target');
        if (!el.hidden && t) el.href = discountHref(t);
      });
    }

    /* fallback echo: the pick landed outside the dish-true format (stockout) —
       say so instead of claiming a tailored combination. */
    function updateEcho(primary, goal) {
      var el = root.querySelector('[data-zpq2-echo]');
      var chain0 = formatChain(state.dish, goal)[0];
      var isFb = !!(primary && primary.getAttribute('data-format') !== chain0);
      if (el) {
        el.textContent = isFb
          ? cfg.echoFallbackTemplate.replace('[goal]', echoLabel('goal', goal))
          : cfg.echoTemplate
              .replace('[dish]', echoLabel('dish', state.dish))
              .replace('[goal]', echoLabel('goal', goal));
      }
      return isFb;
    }

    function updateFreeship(primary) {
      var el = root.querySelector('[data-zpq2-freeship]');
      if (!el) return;
      var showNudge = false, gap = 0;
      if (cfg.freeshipEnabled && primary && primary.getAttribute('data-tier') === '3') {
        var price = parseInt(primary.getAttribute('data-price-cents'), 10);
        // the unlocked CTA applies the code, so the honest gap is post-discount
        var effective = (isUnlocked() && cfg.discount) ? Math.round(price * 0.9) : price;
        gap = cfg.freeshipCents - effective;
        showNudge = gap > 0 && gap <= 1000;
      }
      el.hidden = !showNudge;
      if (showNudge) el.textContent = cfg.freeshipNudge.replace('[amount]', euros(gap));
    }

    /* everything that depends on the picked products — called at render and
       again from the availability-swap path */
    function paintProducts(primary, bundle, goal, params) {
      var isFb = updateEcho(primary, goal);

      fillCard(root.querySelector('[data-zpq2-card="primary"]'), primary, params);
      fillCard(root.querySelector('[data-zpq2-card="bundle"]'), bundle, params);
      var bundleWrap = root.querySelector('[data-zpq2-bundle]');
      if (bundleWrap) bundleWrap.hidden = !bundle;

      updateFreeship(primary);

      // reassurance: strong reframe for the burned, risk-reversal for first-timers
      if (reassureStrongEl) reassureStrongEl.hidden = state.tried !== 'yes';
      if (reassureLightEl) {
        reassureLightEl.hidden = state.tried !== 'no';
        if (state.tried === 'no') {
          var starter = cheapestStarter(primary);
          if (!starter) {
            reassureLightEl.hidden = true; // no honest single-pack anchor → say nothing
          } else {
            var cents = parseInt(starter.getAttribute('data-price-cents'), 10);
            reassureLightEl.textContent = reassureLightTpl
              .replace('[price]', starter.getAttribute('data-price'))
              .replace('[cheap]', cents < 300 ? cfg.reassureLightCheap : '');
          }
        }
      }

      applyGateState(primary, params);
      return isFb;
    }

    var verifyRounds;
    function verifyPicks(primary, bundle, goal, params) {
      if (!window.fetch || !window.Promise) return;
      [[primary, 'primary'], [bundle, 'bundle']].forEach(function (pair) {
        var card = pair[0], slot = pair[1];
        if (!card || verifyRounds[slot] >= 2) return;
        verifyRounds[slot]++;
        checkAvailable(card.getAttribute('data-handle')).then(function (ok) {
          if (ok) return;
          markUnavailable(card);
          var newPrimary = pick(formatChain(state.dish, state.goal || 'lighter'), targetTier(state.freq, state.tried));
          var newBundle = pickBundle(newPrimary);
          paintProducts(newPrimary, newBundle, goal, params);
          verifyPicks(newPrimary, newBundle, goal, params);
        });
      });
    }

    function renderResult() {
      var goal = state.goal || 'lighter';
      var params = REF_BASE + '&zpq_goal=' + encodeURIComponent(goal) + '&zpq_dish=' + encodeURIComponent(state.dish || '');

      var profile = cfg.profiles[goal] || cfg.profiles.lighter;
      root.querySelector('[data-zpq2-profile-emoji]').textContent = profile.emoji;
      root.querySelector('[data-zpq2-profile-name]').textContent = profile.name;
      root.querySelector('[data-zpq2-profile-text]').textContent = profile.text;

      var primary = pick(formatChain(state.dish, goal), targetTier(state.freq, state.tried));
      var bundle = pickBundle(primary);
      var isFb = paintProducts(primary, bundle, goal, params);

      var proofEl = root.querySelector('[data-zpq2-proof]');
      if (proofEl) proofEl.textContent = cfg.proofs[goal] || '';

      var gateText = root.querySelector('[data-zpq2-gate-text]');
      if (gateText) gateText.textContent = cfg.gateTextTemplate.replace('[profile]', lcArticle(profile.name));
      var tags = root.querySelector('[data-zpq-tags]');
      if (tags) tags.value = 'quiz-lead,zpq-' + goal;

      save('result');
      show('result');

      if (debugMode || !sget(K.completeTracked)) {
        if (!debugMode) sset(K.completeTracked, '1');
        track('zpq_complete', { goal: goal, dish: state.dish, tried: state.tried, freq: state.freq, profile: profile.name, fallback: isFb }, debugMode);
      }

      verifyRounds = { primary: 0, bundle: 0 };
      verifyPicks(primary, bundle, goal, params);
    }

    /* storage-blocked postback: email captured but no state to restore — show
       the reward (Liquid-rendered code + ebook inside the locked div) instead
       of dumping the lead back on the intro. */
    function showRewardOnly() {
      show('result');
      ['.zp-quiz2__result-head', '[data-zpq2-echo]', '.zp-quiz2__primary', '[data-zpq2-freeship]',
       '[data-zpq2-reassure="strong"]', '[data-zpq2-reassure="light"]', '[data-zpq2-proof]',
       '[data-zpq2-bundle]', '.zp-quiz2__cta-wrap'].forEach(function (sel) {
        var el = root.querySelector(sel);
        if (el) el.hidden = true;
      });
      if (!rewardUnlockTracked) {
        rewardUnlockTracked = true;
        track('zpq_unlock', { goal: null, mode: 'reward-only' });
      }
      scrollToRoot();
    }

    /* calc interstitial → result (skipped on restore/debug/reduced-motion) */
    function goResult(skipCalc) {
      if (skipCalc || reducedMotion || !steps.calc) { renderResult(); return; }
      show('calc');
      var line = root.querySelector('[data-zpq2-calc-line]');
      var lines = cfg.calcLines || [];
      var i = 0;
      var iv = setInterval(function () {
        i++;
        if (line && lines[i]) line.textContent = lines[i];
        if (i >= lines.length - 1) clearInterval(iv);
      }, 450);
      setTimeout(function () { clearInterval(iv); renderResult(); }, 1350);
    }

    function answer(question, value) {
      state[question] = value;
      save(null);
      track('zpq_answer', { question: question, value: value }, debugMode);
      var idx = STEP_ORDER.indexOf(question);
      var next = STEP_ORDER[idx + 1];
      if (next === 'calc') goResult(false);
      else show(next);
    }

    /* ---- wiring ---- */
    root.querySelectorAll('[data-zpq-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        answer(btn.getAttribute('data-question'), btn.getAttribute('data-value'));
      });
    });
    root.querySelectorAll('[data-zpq-start]').forEach(function (b) {
      b.addEventListener('click', function () {
        track('zpq_start', {}, debugMode);
        show('dish');
      });
    });
    root.querySelectorAll('[data-zpq-back]').forEach(function (b) {
      b.addEventListener('click', function () {
        var cur = root.querySelector('.zp-quiz2__step.is-active');
        var idx = STEP_ORDER.indexOf(cur ? cur.getAttribute('data-zpq-step') : 'dish');
        show(STEP_ORDER[Math.max(0, idx - 1)]);
      });
    });
    root.querySelectorAll('[data-zpq-restart]').forEach(function (b) {
      b.addEventListener('click', function () {
        state = { dish: null, goal: null, tried: null, freq: null };
        sdel(K.state); // unlock + its dedup key survive: a converted lead keeps the code
        show('intro');
      });
    });

    // CTA + result-card clicks → attribution event (synchronous push, fires pre-nav)
    [['cta', root.querySelector('[data-zpq-cta]')],
     ['primary', root.querySelector('[data-zpq2-card="primary"]')],
     ['bundle', root.querySelector('[data-zpq2-card="bundle"]')]]
      .forEach(function (pair) {
        var el = pair[1];
        if (!el) return;
        el.addEventListener('click', function () {
          track('zpq_cta_click', { handle: el.getAttribute('data-handle') || '', slot: pair[0] }, debugMode);
        });
      });
    var ebookBtn = root.querySelector('[data-zpq-ebook]');
    if (ebookBtn) {
      ebookBtn.addEventListener('click', function () {
        track('zpq_ebook_click', { goal: state.goal }, debugMode);
      });
    }

    /* Shopify's default redirect after /contact drops the query string, which kills
       ?view=quiz-v2 previews. Send it back to the exact current URL (minus the debug
       hook) with customer_posted=true appended so the postback is always detectable. */
    function returnTarget() {
      var parts = location.search.replace(/^\?/, '').split('&').filter(function (p) {
        return p && !/^(customer_posted|zpq2)=/.test(p);
      });
      parts.push('customer_posted=true');
      return location.pathname + '?' + parts.join('&');
    }
    var returnInput = root.querySelector('[data-zpq-return]');
    if (returnInput) returnInput.value = returnTarget();

    /* email gate: flag BEFORE the native form navigates away, confirm on postback */
    var gateForm = root.querySelector('[data-zpq-gate] form');
    if (gateForm) {
      gateForm.addEventListener('submit', function () {
        sset(K.pending, '1');
        save('result');
        var tags = root.querySelector('[data-zpq-tags]');
        if (tags && state.goal) tags.value = 'quiz-lead,zpq-' + state.goal;
        if (returnInput) returnInput.value = returnTarget();
        track('zpq_email_submit', { goal: state.goal }, debugMode);
      });
    }

    function scrollToRoot() {
      window.scrollTo(0, root.getBoundingClientRect().top + window.pageYOffset - 20);
    }

    /* ---- boot: debug hook, else postback/restore ---- */
    var dbg = parseDebug();
    if (dbg) {
      debugMode = true;
      QUESTIONS.forEach(function (q) { if (dbg[q]) state[q] = dbg[q]; });
      if (dbg.unlock === '1') sset(K.unlock, '1');
      var target = dbg.step || 'intro';
      if (target === 'result') goResult(true);
      else if (target === 'calc') { show('calc'); }
      else show(target);
      return;
    }

    var restored = null;
    try { restored = JSON.parse(sget(K.state) || 'null'); } catch (e) {}
    var posted = !!root.querySelector('[data-zpq-posted]') || /[?&]customer_posted=/.test(location.search);
    var hasErrors = !!root.querySelector('[data-zpq-form-errors]');
    var pending = sget(K.pending) === '1';
    if (pending) sdel(K.pending);

    if (restored && restored.goal) {
      state = restored;
      if (posted && (pending || restored.step === 'result')) {
        sset(K.unlock, '1');
        goResult(true);
        if (!sget(K.unlockTracked)) { sset(K.unlockTracked, '1'); track('zpq_unlock', { goal: state.goal }); }
        scrollToRoot();
      } else if (hasErrors && restored.step === 'result') {
        goResult(true); // gate stays locked; Liquid already renders the error
        scrollToRoot();
      } else if (restored.step === 'result' && isUnlocked()) {
        goResult(true); // returning visitor in the same session: keep it unlocked
      }
    } else if (root.querySelector('[data-zpq-posted]')) {
      // the server confirmed the post but sessionStorage gave us nothing back
      // (ITP/private mode): the Liquid fallback block holds the reward — show it
      showRewardOnly();
    }
  }

  function boot() {
    document.querySelectorAll('[data-zp-quiz2]').forEach(initQuiz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
